import { Dispatch, FC, SetStateAction } from 'react';

import { EditCellSidebar, EditCellWrapper } from './components';

import { EditCellChartRenderer } from './components/EditCellChartRenderer';
import { DimensionValue } from './components/EditCellSidebar/constants';
import { FieldSelections, SetFieldSelections } from './components/EditCellSidebar/EditCellSidebar';

export type SetSelectedDimension = Dispatch<SetStateAction<DimensionValue>>;

type EditCellProps = {
  sidebarTitle: string;
  selectedDimension: DimensionValue;
  fieldSelections: FieldSelections;
  setFieldSelections: SetFieldSelections;
  setSelectedDimension: SetSelectedDimension;
  onSaveClick: (fieldSelections: FieldSelections) => void;
  onCancelClick: () => void;
};

export const EditCell: FC<EditCellProps> = ({
  sidebarTitle,
  selectedDimension,
  fieldSelections,
  setFieldSelections,
  setSelectedDimension,
  onCancelClick,
  onSaveClick,
}) => {
  return (
    <EditCellWrapper
      chartContent={<EditCellChartRenderer selectedDimension={selectedDimension} />}
      sideBarContent={
        <EditCellSidebar
          selectedDimension={selectedDimension}
          fieldSelections={fieldSelections}
          setFieldSelections={setFieldSelections}
          setSelectedDimension={setSelectedDimension}
          title={sidebarTitle}
          onCancelClick={onCancelClick}
          onSaveClick={onSaveClick}
        />
      }
    />
  );
};
